module.exports = __webpack_public_path__ + "img/nodata.50a3af19.svg";